<div class="modal-content">
  <div class="modal-header modal-header--bordered">
    <h1 class="mb-0" data-automation="detailed-modal-title">
      <a id="eula-link" [href]="url" target="_blank">
        <strong class="text-primary">
          {{ 'tkey;eula.modal.title' | translate }}
          <i class="{{ ziroIcons.EXTERNAL_LINK }} release-notes-icon"></i>
        </strong>
      </a>
    </h1>
  </div>

  <div
    #modalBody
    class="modal-body modal-body--dynamic modal-body--dynamic__scrollable p-5 pt-4"
    data-automation="prompt-modal-body"
  >
    <div
      class="alert alert-info"
      data-automation="eula-modal-alert"
      [innerHtml]="'tkey;eula.modal.alert' | escapeHtml"
    ></div>
    <div data-automation="eula-modal-text" [innerHTML]="html | escapeHtml"></div>
  </div>
  <div class="modal-footer modal-footer--bordered">
    <span
      [ngbTooltip]="'tkey;eula.modal.button.accept.tooltip.disabled' | translate"
      [disableTooltip]="isScrolledToBottom()"
    >
      <button
        type="button"
        class="btn btn-border btn-lg btn-outline-primary"
        (click)="onAcceptClick()"
        [attr.data-automation]="'detailed-modal-accept-button'"
        [disabled]="!isScrolledToBottom()"
      >
        {{ 'tkey;eula.modal.button.accept' | translate }}
      </button>
    </span>
  </div>
</div>
